module.exports = __webpack_public_path__ + "static/media/B&WCandlestick.9179b59b.png";